import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector: "[nest][formControlName],[nest][formControl],[nest][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NestValidator),
      multi: true,
    },
  ],
})
export class NestValidator implements Validator {
  // 	nests : any;

  constructor(@Attribute("nest") public nest: any) {
    //     	if (localStorage.getItem('nests'))
    //     		this.nests = JSON.parse(localStorage.getItem('nests'));
  }

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // value not equal
    if (v && !v.nestId) {
      return {
        nest: false,
      };
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/nest.validator.ts